export const retryOutcomeHeaders = {
  outcome: 'X-Inav-Retry-Outcome',
  failureType: 'X-Inav-Failure-Type'
} as const;

export function hasTransientRetryStop(headers: Headers): boolean {
  return headers.get(retryOutcomeHeaders.outcome) === 'stop'
    && headers.get(retryOutcomeHeaders.failureType) === 'transient';
}